export const HOTEL = {
  name: "Hotel Vijayshree Inn",
  nameHindi: "होटल विजयश्री इन",
  rating: 3.9,
  reviews: 20,
  phone: "+91 95791 30878",
  phoneRaw: "+919579130878",
  email: "stay@vijayshreeinn.in",
  address: "Parate Corner, Square, Wardha Rd, Kamala Chowk, Khamla, Nagpur, Maharashtra 440025",
  neighborhood: "Khamla, Wardha Road Commercial Hub",
  whatsapp: "919579130878",
  whatsappDisplay: "+91 95791 30878",
  mapQuery: "Hotel Vijayshree Inn Khamla Nagpur Maharashtra 440025",
};

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1711059985570-4c32ed12a12c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Standard Double Room", category: "Rooms" },
  { url: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Deluxe AC Room", category: "Rooms" },
  { url: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Executive Suite", category: "Rooms" },
  { url: "https://images.unsplash.com/photo-1759038086832-795644825e3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Reception & Check-in Desk", category: "Lobby & Reception" },
  { url: "https://images.unsplash.com/photo-1648960456182-00643d5d20eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Lobby Lounge", category: "Lobby & Reception" },
  { url: "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Guest Lounge", category: "Lobby & Reception" },
  { url: "https://images.unsplash.com/photo-1696029475645-b43b9f9092cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Evening Exterior", category: "Neighborhood" },
  { url: "https://images.unsplash.com/photo-1571440727633-ca6b05da2008?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Wardha Road Facade", category: "Neighborhood" },
];

export const TRANSIT = [
  { name: "Kamala Chowk Metro Station", distance: "0.3 km · ~3 min walk", icon: "TrainFront" },
  { name: "Dr. B. R. Ambedkar Intl. Airport (NAG)", distance: "3.5 km · ~10 min drive", icon: "Plane" },
  { name: "Ajni Railway Station", distance: "4.2 km · ~12 min drive", icon: "Train" },
  { name: "Nagpur Junction Railway Station", distance: "6.8 km · ~18 min drive", icon: "Train" },
];

export const ATTRACTIONS = [
  { name: "Deekshabhoomi Monument", distance: "3.1 km" },
  { name: "Ambazari Lake & Garden", distance: "4.0 km" },
  { name: "Empress City Mall", distance: "5.0 km" },
  { name: "Futala Lake Promenade", distance: "6.5 km" },
];

export const RATING_BREAKDOWN = [
  { label: "Location", value: 4.5 },
  { label: "Value for Money", value: 4.3 },
  { label: "Service", value: 4.1 },
  { label: "Cleanliness", value: 4.0 },
];

export const REVIEWS = [
  { author: "Rajesh Kulkarni", rating: 5, date: "1 month ago", comment: "Very convenient location right at Parate Corner, Khamla. Perfect for quick business travel to Nagpur. Rooms are clean and AC works great for ₹1,500!" },
  { author: "Priya Sharma", rating: 4, date: "2 months ago", comment: "Close to Nagpur airport and Kamala Chowk. Staff was helpful with early check-in. Great budget stay in Wardha Road area." },
  { author: "Amit Deshmukh", rating: 4, date: "3 months ago", comment: "Good value for money. Neat double room with hot water and fast Wi-Fi. Recommend for families travelling through Nagpur." },
  { author: "Sneha Rao", rating: 4, date: "3 months ago", comment: "Simple, clean and affordable. The staff arranged an airport cab quickly. Would stay again on my next Nagpur trip." },
];

export const AMENITIES = [
  { icon: "Wifi", label: "High-Speed Wi-Fi" },
  { icon: "Snowflake", label: "Air Conditioning" },
  { icon: "Tv", label: "Flat Screen TV" },
  { icon: "Droplets", label: "24h Hot Water" },
  { icon: "Car", label: "Free Parking" },
  { icon: "Coffee", label: "Tea / Coffee" },
  { icon: "Utensils", label: "In-Room Dining" },
  { icon: "ConciergeBell", label: "24h Front Desk" },
];
